/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/lodash/_baseLodash.js
// module id = 399
// module chunks = 168707334958949